/* unplugin-vue-components disabled */import script from "./detail.vue?vue&type=script&setup=true&lang=js"
export * from "./detail.vue?vue&type=script&setup=true&lang=js"

import "./detail.vue?vue&type=style&index=0&id=2b5e0002&lang=scss"

const __exports__ = script;

export default __exports__